import React from 'react';
import { FormattedMessage } from 'react-intl';
import { getAssetUrl } from '../../../utils/GetAssetUrl';
import './NotFound.component.scss';

export function NotFoundComponent(props: any) {
  function goHome() {
    window.location.href = `${process.env.REACT_APP_BASE_URL}`;
  }

  return (
    <div className='page-not-found-container d-flex justify-content-center align-items-center flex-column flex-nowrap'>
      <div
        className='image-container'
        style={{
          backgroundImage: `url(${getAssetUrl.icons('LILI_HOME.svg')})`,
        }}
      ></div>
      <div className='title'>
        <FormattedMessage id='pages.not-found.title'></FormattedMessage>
      </div>
      <div className='subtitle'>
        <FormattedMessage id='pages.not-found.subtitle'></FormattedMessage>
      </div>
      <div className='message'>
        <FormattedMessage id='pages.not-found.message'></FormattedMessage>
      </div>
      <div className='home-link'>
        <button className='btn-lili' onClick={() => goHome()}>
          <FormattedMessage id='pages.not-found.button'></FormattedMessage>
        </button>
      </div>
    </div>
  );
}
